// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const invLocationId = (z.number());
export const invLocation = z.object({
    id: invLocationId,
    name: z.string(),
    parent_id: invLocationId.nullable(),
    path: z.string().nullable(),
    description: z.string().nullable(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
});
export const invLocationInitializer = z.object({
    id: invLocationId.optional(),
    name: z.string(),
    parent_id: invLocationId.optional().nullable(),
    path: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
export const invLocationMutator = z.object({
    id: invLocationId.optional(),
    name: z.string().optional(),
    parent_id: invLocationId.optional().nullable(),
    path: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
//# sourceMappingURL=InvLocation.js.map